
<template>

  <div class="card card-front sp-outer font-card" style="overflow:show">
    <header class="card-header">
      <div class="status full-status" style="background-color:rgb(0,153,191);"></div>
      <div class="ob-header card-header">
        <div class="card-title">
          <h3>{{clauses.alertSP}}</h3>
          <h6>{{room.info.hvacName}}</h6>
        </div>
        <div
          class="sp-cur"
          :style="{
            'border-top': `2px solid ${$store.getters.rdgStatus({rdg: spNodes()[activeNode].val, did: room.did}).color}`,
            'border-left': `2px solid ${$store.getters.rdgStatus({rdg: spNodes()[activeNode].val, did: room.did}).color}`,
            'border-bottom': `2px solid ${$store.getters.rdgStatus({rdg: spNodes()[activeNode].val, did: room.did}).color}`,
            'border-right': 'none',
            'color': $store.getters.rdgStatus({rdg: spNodes()[activeNode].val, did: room.did}).color,
            'margin-left': '8px'
          }">
          <h3 :style="{}">
            {{setMetricStandardRdg()}}
            <span style="font-size:.6em;margin-left:5px;">
              {{typeof setMetricStandardRdg() != 'string' ? `${spNodes()[activeNode].units}` : ''}}
            </span>
          </h3>
          <h5 style="font-size:.6em;">{{clauses.cur}}</h5>
        </div>
      </div>
      <div class="card-head-sep"></div>
    </header>
    <div class="card-body sp-body" style="justify-content:flex-start;" v-if="!primeReset">
      <div class="sp-nodes">
        <div v-for="(node, index) in spNodes()" :class="activeNode === index ? 'sp-node active-sp-node' : 'sp-node'" @click="switchNode(index)">
          <v-popover offset="3" trigger="hover" placement="bottom">
            <img :src="`https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/${node.img}.png`" />
            <template slot="popover">
              <hover-component :options="{type: 'mini', text: node.title}"></hover-component>
            </template>
          </v-popover>
        </div>
      </div>
      <div class="ranges">

        <slider-component
          v-for="slider in sliders"
          :range="slider.range"
          :min="slider.min"
          :max="slider.max"
          :tier="slider.tier"
          :title="slider.title"
          :val="slider.val"
          :index="slider.index"
          :newSlide="slider.newSlide"
          v-on:updateRange="accumNew($event)"
          v-if="sliders.length">
        </slider-component>

      </div>

      <div class="ob-btns" style="margin-bottom:2%;" v-if="!primeReset">
        <a class="land-btn ob-btn sec-btn" @click="resetAndReturn">{{clauses.back}}</a>
        <a class="land-btn ob-btn tre-btn" @click="primeReset = true">{{clauses.reset}}</a>
        <a class="land-btn ob-btn prim-btn" @click="sendPostSp(false)">{{clauses.saveChanges}}</a>
      </div>
    </div>


    <div class="card-body sp-body prime-reset-body" style="justify-content:flex-start;" v-if="primeReset">
      <h3 style="color:red;">Delete All Custom Setpoints?</h3>
      <p style="margin-bottom:15%;">
        By selecting "Confirm" below, you will reset the Alert Setponts for this device to the factory default. This action can not be undone.
      </p>
      <a class="land-btn wide-btn prim-btn" @click="sendPostSp(true)">{{clauses.conf}}</a>
      <a class="land-btn wide-btn sec-btn" @click="primeReset = false">{{clauses.cancel}}</a>
    </div>
  </div>

</template>

<script>

import axios from 'axios';
import cToF from 'celsius-to-fahrenheit';
import fToC from 'fahrenheit-to-celsius';

import { mapState } from 'vuex';

import Generate from '@/lib/genThresh';
import Lang from '@/lib/langTemplates/CardTemplate';

import Slider from './Slider';
import Hover from '../hover/Hover';

export default {

  data(){
    return {
      // setpoints: {},
      activeNode: 1,
      activeTier: 'crit2',
      postSp: {},
      sliders: [],
      primeReset: false,
      updated: false
    }
  },

  props: ['room'],

  components: {
    'slider-component': Slider,
    'hover-component': Hover
  },

  computed: {
    clauses(){
      let lPref = this.$store.state.lang;
      return Object.keys(Lang.clauses).reduce((a, i) => {
        a[i] = Lang.clauses[i][lPref];
        return a;
      }, {});
    },
    setpoints(){
      let sp = normalizeSetpoints(this.$store.getters.getRoomSetpoints(this.room.did));
      if (sp.voc.max <= 1) {
        ['min', 'max'].forEach(prop => sp.voc[prop] *= 1000);
        ['good', 'bad', 'crit'].forEach(x => {
          sp.voc[x].min *= 1000;
          sp.voc[x].max *= 1000;
        });
      }
      return sp;
    }
  },

  methods: {

    spNodes(){
      return [
        {
          title: this.room.info.coilSensor ? 'Coil Pressure' : 'Filter Condition',
          img: this.room.info.coilSensor ? 'coilFlow' : 'filterOfficial',
          val: this.room.info.coilSensor ? 'deltaPressure95Percentile' : 'days',
          units: this.room.info.coilSensor ? (this.$store.state.user.pressure ? 'Pa' : 'iwg') : 'days'
        },
        {
          title: 'Temperature',
          img: 'temp',
          val: 'ttp',
          units: this.$store.state.user.metric ? '˚C' : '˚F'
        },
        {
          title: 'Humidity',
          img: 'hum',
          val: 'hhm',
          units: '%'
        },
        {
          title: 'IAQ Index',
          img: 'iaq',
          val: 'iaq',
          units: ''
        },
        {
          title: 'CO2',
          img: 'eCO2',
          val: 'co2',
          units: 'ppm'
        },
        {
          title: 'tVOC',
          img: 'nuevoVOC',
          val: 'voc',
          units: 'ppm'
        }
      ]
    },

    switchNode(x){
      this.activeNode = x;
      const rdg = this.spNodes()[x];
      this.genSliders(rdg.val);
      this.newVal = false;
    },

    meterNode(){
      const rdg = this.spNodes()[this.activeNode].val;
      let tiers = ['crit2', 'bad2', 'good', 'bad', 'crit'].map(i => {
        if (this.setpoints[rdg][i]) {
          let node = {
            tier: i,
            rdg: parseTier(i),
            class: parseClass(i, this.setpoints[rdg]),
            min: this.setpoints[rdg][i].min,
            max: this.setpoints[rdg][i].max
          };
          return node;
        } else {
          return null;
        }
      }).filter(x => x !== null);
      return rdg === 'days' ? tiers.reverse() : tiers;
    },

    bad2Min(){
      return this.setpoints[this.spNodes()[this.activeNode].val].bad2
        ? parseInt(this.setpoints[this.spNodes()[this.activeNode].val].bad2.max) + 1
        : parseInt(this.setpoints[this.spNodes()[this.activeNode].val].min);
    },

    genSliders(rdg, newSlide){
      const sp = this.setpoints[rdg];
      if (rdg === 'days') {
        this.sliders = [
          new Slide(sp.good, sp.min, sp.max, 'good', 'Good', rdg, 2),
          new Slide(sp.bad, sp.min, sp.good.min, 'bad', 'Warning', rdg, 1),
          new Slide(sp.crit, sp.min, sp.bad.min, 'crit', 'Critical', rdg, 0)
        ];
      } else if (['ttp', 'hhm'].includes(rdg)) {
        this.sliders = [
          new Slide(sp.crit, sp.min, sp.max, 'crit', 'Critical High', rdg, 4, this.$store.state.user.metric),
          new Slide(sp.bad, sp.min, sp.crit.min, 'bad', 'Warning High', rdg, 3, this.$store.state.user.metric),
          new Slide(sp.good, sp.min, sp.bad.min, 'good', 'Good', rdg, 2, this.$store.state.user.metric),
          new Slide(sp.bad2, sp.min, sp.good.min, 'bad2', 'Warning Low', rdg, 1, this.$store.state.user.metric),
          new Slide(sp.crit2, sp.min, sp.bad2.min, 'crit2', 'Critical Low', rdg, 0, this.$store.state.user.metric),
        ];
      } else if (['iaq', 'co2', 'voc', 'deltaPressure95Percentile'].includes(rdg)) {
        this.sliders = [
          new Slide(sp.crit, sp.min, sp.max, 'crit', 'Critical', rdg, 2, this.$store.state.user.pressure),
          new Slide(sp.bad, sp.min, sp.crit.min, 'bad', 'Warning', rdg, 1, this.$store.state.user.pressure),
          new Slide(sp.good, sp.min, sp.bad.min, 'good', 'Good', rdg, 0, this.$store.state.user.pressure)
        ];
      }
      if (newSlide) this.sliders.forEach(s => s.newSlide = true);
    },

    accumNew(event){

      this.updated = true;
      const sp = this.setpoints[event.val];
      if (['hhm', 'ttp'].includes(event.val)) {
        switch (event.tier) {
          case 'crit':
            this.sliders[1].max = event.newValue - 1;
            if (!this.$store.state.user.metric && event.val === 'ttp') {
              const cel = Math.round(fToC(parseInt(event.newValue)));
              this.postSp[event.val].bad.max = cel - 1;
              this.postSp[event.val].crit.min = cel;
              if (cel < sp.bad.min + 1) {
                sp.bad.min = sp.bad.max - 1;
              }
            } else {
              sp.bad.max = event.newValue - 1;
              if (event.newValue < sp.bad.min + 1) {
                sp.bad.min = sp.bad.max - 1;
              }
            }
          break;
          case 'bad':
            this.sliders[2].max = event.newValue - 1;
            if (!this.$store.state.user.metric && event.val === 'ttp') {
              const cel = Math.round(fToC(parseInt(event.newValue)));
              this.postSp[event.val].good.max = cel - 1;
              this.postSp[event.val].bad.min = cel;
              if (cel < sp.good.min + 1) {
                sp.good.min = sp.good.max - 1;
              }
            } else {
              sp.good.max = event.newValue - 1;
              if (event.newValue < sp.good.min + 1) {
                sp.good.min = sp.good.max - 1;
              }
            }
          break;
          case 'good':
            this.sliders[3].max = event.newValue - 1;
            if (!this.$store.state.user.metric && event.val === 'ttp') {
              const cel = Math.round(fToC(parseInt(event.newValue)));
              this.postSp[event.val].bad2.max = cel - 1;
              this.postSp[event.val].good.min = cel;
              if (cel < sp.bad2.min + 1) {
                sp.bad2.min = sp.bad2.max - 1;
              }
            } else {
              sp.bad2.max = event.newValue - 1;
              if (event.newValue < sp.bad2.min + 1) {
                sp.bad2.min = sp.bad2.max - 1;
              }
            }
          break;
          case 'bad2':
          this.sliders[4].max = event.newValue - 1;
            sp.crit2.max = event.newValue - 1;
          break;
        }
      } else if (['iaq', 'co2', 'voc', 'deltaPressure95Percentile'].includes(event.val)) {
        switch (event.tier) {
          case 'crit':
            this.sliders[1].max = event.newValue - 1;
            sp.bad.max = event.newValue - 1;
            if (event.newValue < sp.bad.min + 1) {
              sp.bad.min = sp.bad.max - 1;
            }
          break;
          case 'bad':
            this.sliders[2].max = event.newValue - 1;
            sp.good.max = event.newValue - 1;
          break;
        }
      } else if (event.val == 'days') {
        if (event.tier === 'good') {
          this.sliders[1].max = event.newValue - 1;
          sp.bad.max = event.newValue - 1;
          if (event.newValue < sp.bad.min + 1) {
            sp.bad.min = sp.bad.max - 1;
          }
        } else if (event.tier === 'bad') {
          this.sliders[2].max = event.newValue - 1;
          sp.crit.max = event.newValue - 1;
        }
      }
    },

    async sendPostSp(del){
      if (this.postSp.voc.max > 1) {
        ['min', 'max'].forEach(prop => this.postSp.voc[prop] /= 1000);
        ['good', 'bad', 'crit'].forEach(x => {
          this.postSp.voc[x].min /= 1000;
          this.postSp.voc[x].max /= 1000;
        });
      }
      del
       ? await this.$store.dispatch('resetSp', this.room.did)
       : await this.$store.dispatch('postNewSp', {did: this.room.did, data: this.postSp});
      this.$emit('setRefresh');
      this.$emit('initFlip', {from: 'setpoints', to: 'front'});
    },

    truncate(name, max, end){
      return name.length < max ? name : name.substr(0, end) + '...'
    },

    setMetricStandardRdg(){
      const val = this.spNodes()[this.activeNode].val;
      let rdg = this.room.meas[val];
      if (val !== 'voc' ) {
        if (val == 'ttp') {
          rdg = this.$store.state.user.metric
            ? Math.round(this.room.meas[val])
            : Math.round(cToF(parseInt(this.room.meas[val])));
        } else if (val == 'deltaPressure95Percentile') {
          rdg = this.$store.state.user.pressure
            ? Math.round(this.room.meas[val])
            : parseFloat((this.room.meas[val] / 249.082).toFixed(2));
        }
        if (parseInt(rdg) || rdg < 1) {
          if (parseInt(rdg) - rdg !== 0) {
            rdg = rdg.toFixed(2);
          }
          return rdg;
        } else {
          return '-'
        }
      } else {
        try {
          const voc = parseFloat(this.room.meas.voc);
          return isNaN(voc) ? 'Calib.' : voc;
        } catch(err) {
          console.log(err);
          return 'Calib.'
        }
      }
    },

    resetAndReturn(){
      if (this.updated){
        this.$emit('setRefresh');
      }
      this.$emit('initFlip', {from: 'setpoints', to: 'front'})
    }

  },

  mounted(){
    this.genSliders('ttp', true);
    this.postSp = this.setpoints;
  }

}

function normalizeSetpoints(sp){
  let template = Generate;
  Object.keys(template).forEach(k => {
    if (!sp[k]) sp[k] = template[k];
    Object.keys(template[k]).forEach(x => {
      if (!sp[k][x]) sp[k][x] = template[k][x];
    })
  });
  return sp;
}

function parseTier(r){
  switch (r) {
    case 'crit2':
      return 'Crit Low';
    break;
    case 'crit':
      return 'Crit';
    break;
    case 'bad2':
      return 'Warn Low'
    break;
    case 'bad':
      return 'Warn'
    break;
    case 'good':
      return 'Good';
    break;
  }
}

function parseClass(t, sp){
  if (['crit2', 'crit'].includes(t)) {
    return 'crit';
  } else if (t === 'good') {
    if (!sp.bad2) {
      return 'dark-good'
    } else {
      return 'good'
    }
  } else {
    return 'bad';
  }
}

function parseColor(tier){
  if (['bad', 'bad2'].includes(tier)) return '#c7ac4e';
  if (['crit', 'crit2'].includes(tier)) return '#a82232';
  if (tier === 'good') return '#66ad5f';
}

class Slide {
  constructor(range, min, max, tier, title, val, index, metric){
    this.range = (!metric && val === 'ttp') ? {min: Math.round(cToF(parseInt(range.min))), max: Math.round(cToF(parseInt(range.max)))} : range;
    this.min = (!metric && val === 'ttp') ? Math.round(cToF(parseInt(min))) : min;
    this.max = (!metric && val === 'ttp') ? Math.round(cToF(parseInt(max))) : max;
    this.tier = tier;
    this.title = title;
    this.val = val;
    this.index = index;
    if (val == 'deltaPressure95Percentile') {
      console.log(range);
    }
  }
}

</script>

<style>

.sp-outer {
  border: 2px solid gray;
  overflow: hidden;

}

.sp-nodes {
  margin-top: 10px;
  width: 100%;
  height: 45px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
}

.sp-node {
  width: 20%;
  height: 45px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background-color: #325468;
}

.sp-body {
  height: 80%;
}

.sp-node h6 {
  margin: 2px;
}

.sp-node img {
  height: 25px;
}

.active-sp-node {
  /* height: 50px; */
  background-color: rgb(0, 153, 191);
  height: 45px;
  /* padding: 5px; */
}

.sp-title h5 {
  color: rgb(0, 153, 191);
  text-decoration: underline;
  font-weight: lighter;
}

.sp-meter {
  width: 95%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.meter-node {
  width: 20%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border: 1px solid #dce1ec;
}

.meter-node h5, .meter-node h6 {
  margin: 0px;
}

.good-meter {
  background-color: #66ad5f;
}

.dark-good-meter {
  background-color: rgba(0, 0, 0, 0.8);
  color: #66ad5f;
}

.crit-meter {
  background-color: rgba(0, 0, 0, 0.8);
  color: #a82232;
}

.bad-meter {
  background-color: #c7ac4e;
}

.ranges {
  width: 100%;
  height: 53%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin-top: 4%;
  margin-bottom: 5.5%;
}

.range-node {
  width: 85%;
  min-height: 50px;
  max-height: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  margin: 4px;
}

.range-node h6 {
  margin: 2px;
}

.warn-node {
  background-color: #c7ac4e;
}

.good-node {
  background-color: #66ad5f;
}

.crit-node {
  background-color: #a82232;
}

.range-node input {
  width: 95%;
}

.sp-cur {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 50px;
  width: 120px;
  overflow: hidden;
}

.sp-cur h3 {
  width: 95%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0px;
  text-align: center;
}

.sp-cur h5 {
  width: 95%;
  justify-content: flex-start;
  align-items: center;
  margin: 0px;
  text-align: center;
}

.prime-reset-body {
  width: 80%;
  text-align: center;
  align-self: center;
  margin-left: 10%;
}

.wide-btn {
  width: 70%;
}

</style>



// WEBPACK FOOTER //
// src/components/setpoints/Setpoints.vue